module.exports = "<!-- <h1>{{title}}</h1> -->\r\n<div #chartTarget>\r\n  chart target\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/bar-graph/bar-graph.component.html
// module id = ./src/app/modules/dashboard/bar-graph/bar-graph.component.html
// module chunks = main